// extracted by mini-css-extract-plugin
export default {"edit_name_container":"edit-name_edit_name_container__v69SL","confirm_button":"edit-name_confirm_button__52X0S","cancel_button":"edit-name_cancel_button__q5OS-"};